"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _usageTracker = _interopRequireDefault(require("../../lib/usageTracker"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _HomepageForm = _interopRequireDefault(require("../HomepageForm"));

var _LanguageSwitcher = _interopRequireDefault(require("../LanguageSwitcher"));

var _DocumentHead = _interopRequireDefault(require("../portals/DocumentHead"));

var _Canonical = _interopRequireDefault(require("../Canonical"));

var _Hreflang = _interopRequireDefault(require("../Hreflang"));

var _Languages = _interopRequireDefault(require("../../constants/Languages"));

var _Urls = require("../../util/Urls");

var languages = Object.keys(_Languages.default);

var _default = function _default(_ref) {
  var location = _ref.location,
      url = _ref.match.url;
  (0, _react.useEffect)(function () {
    _usageTracker.default.logView('Home');
  }, []);

  var renderWelcomeBanner = function renderWelcomeBanner() {
    switch (location.search) {
      case 'producthunt':
        return _react.default.createElement(_AlertMessage.default, {
          message: "home.productHuntMessage"
        });

      case 'mg':
        return _react.default.createElement(_AlertMessage.default, {
          message: "home.marketingGraderMessage"
        });

      default:
    }

    return undefined;
  };

  return _react.default.createElement("div", {
    className: "home-page"
  }, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_Canonical.default, {
    to: url
  }), _react.default.createElement(_Hreflang.default, {
    href: (0, _Urls.getLocalizedUrl)('en'),
    lang: "x-default"
  }), languages.map(function (lang) {
    return _react.default.createElement(_Hreflang.default, {
      key: lang,
      href: (0, _Urls.getLocalizedUrl)(lang),
      lang: lang
    });
  })), _react.default.createElement("div", null, renderWelcomeBanner(), _react.default.createElement(_LanguageSwitcher.default, null), _react.default.createElement(_Logo.default, null), _react.default.createElement("h1", {
    className: "title"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "meta.title"
  })), _react.default.createElement("div", {
    className: "subtitle"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "home.title"
  })), _react.default.createElement(_HomepageForm.default, null)));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/HomePage.js
// module id = 246
// module chunks = 0